import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';
import {
  LoadProjectsParams,
  ApiResponse,
  ProjectTagPayload,
  SystemProjectTagPayload,
  GlobalParams,
  FilterParams,
  DefaultsActionData
} from './fir-163j-tagging.types';

@Injectable({
  providedIn: 'root'
})
export class Fir163jTaggingService {

  constructor(private http: HttpClient) { }

  loadProjects(baseUrl: string, params: LoadProjectsParams): Observable<ApiResponse> {
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });
    const queryString = urlEncoded.toString();
    const url = `${baseUrl}/loadJsonObject${queryString ? '?' + queryString : ''}`;
    return this.http.get<any>(url, { withCredentials: true });
  }

  saveProjectTag(baseUrl: string, tags: ProjectTagPayload[], globalParams: GlobalParams, filterParams: FilterParams): Observable<ApiResponse> {
    const url = `${baseUrl}/saveJsonObject?action_code=6awamo`;
    
    const data = { jsonObj: JSON.stringify(tags) };
    const jsonSettings = [{
      tax_year: filterParams.tax_year,
      scenario: filterParams.scenario,
      jcd_key: globalParams.jcd_key === '' || globalParams.jcd_key === undefined ? 250 : globalParams.jcd_key
    }];
    
    let params: any = { ...filterParams, ...data };
    params = { ...globalParams, ...params };
    params = { ...params, jsonSetting: JSON.stringify(jsonSettings) };
    
    const formData = new FormData();
    Object.keys(params).forEach(key => {
      formData.append(key, params[key]);
    });
    
    const options = { withCredentials: true };
    return this.http.post<any>(url, formData, options);
  }

  saveSystemProjectTag(baseUrl: string, tags: SystemProjectTagPayload[], globalParams: GlobalParams, filterParams: FilterParams): Observable<ApiResponse> {
    const url = `${baseUrl}/saveJsonObject?action_code=zopevh`;
    
    const data = { jsonObj: JSON.stringify(tags) };
    const jsonSettings = [{
      tax_year: filterParams.tax_year,
      scenario: filterParams.scenario,
      jcd_key: globalParams.jcd_key === '' || globalParams.jcd_key === undefined ? 250 : globalParams.jcd_key
    }];
    
    let params: any = { ...filterParams, ...data };
    params = { ...globalParams, ...params };
    params = { ...params, jsonSetting: JSON.stringify(jsonSettings) };
    
    const formData = new FormData();
    Object.keys(params).forEach(key => {
      formData.append(key, params[key]);
    });
    
    const options = { withCredentials: true };
    return this.http.post<any>(url, formData, options);
  }

  applyDefaults(baseUrl: string, data: DefaultsActionData, details: any[], globalParams: GlobalParams, filterParams: FilterParams): Observable<ApiResponse> {
    const url = `${baseUrl}/saveJsonObject?action_code=0swobv`;
    
    const jsonObj = JSON.stringify(details);
    const jsonSettings = JSON.stringify(data);
    
    let params: any = { ...filterParams };
    params.combination_key = data.combination_key;
    params.sso_id = data.sso_id;
    params = { ...globalParams, ...params };
    params = { ...params, clob_data: jsonObj };
    params = { ...params, clob_settings: jsonSettings };
    params.process_name = "APPLY_DEFAULT_163J_TAGS";
    
    const formData = new FormData();
    Object.keys(params).forEach(key => {
      formData.append(key, params[key]);
    });
    
    const options = { withCredentials: true };
    return this.http.post<any>(url, formData, options);
  }

  resetDefaults(baseUrl: string, data: DefaultsActionData, details: any[], globalParams: GlobalParams, filterParams: FilterParams): Observable<ApiResponse> {
    const url = `${baseUrl}/saveJsonObject?action_code=73go4u`;
    
    const jsonObj = JSON.stringify(details);
    const jsonSettings = JSON.stringify(data);
    
    let params: any = { ...filterParams };
    params.combination_key = data.combination_key;
    params.sso_id = data.sso_id;
    params = { ...globalParams, ...params };
    params = { ...params, clob_data: jsonObj };
    params = { ...params, clob_settings: jsonSettings };
    params.process_name = "RESET_DEFAULT_163J_TAGS";
    
    const formData = new FormData();
    Object.keys(params).forEach(key => {
      formData.append(key, params[key]);
    });
    
    const options = { withCredentials: true };
    return this.http.post<any>(url, formData, options);
  }

  syncForm(baseUrl: string, data: DefaultsActionData, details: any[], globalParams: GlobalParams, filterParams: FilterParams): Observable<ApiResponse> {
    const url = `${baseUrl}/saveJsonObject?action_code=fo0v1g`;
    
    const jsonObj = JSON.stringify(details);
    const jsonSettings = JSON.stringify(data);
    
    let params: any = { ...filterParams };
    params.combination_key = data.combination_key;
    params.sso_id = data.sso_id;
    params = { ...globalParams, ...params };
    params = { ...params, clob_data: jsonObj };
    params = { ...params, clob_settings: jsonSettings };
    params.process_name = "SYNC_163J_TO_FORM_8990";
    
    const formData = new FormData();
    Object.keys(params).forEach(key => {
      formData.append(key, params[key]);
    });
    
    const options = { withCredentials: true };
    return this.http.post<any>(url, formData, options);
  }
}
